import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'components/ui'

const KBMockupTriggerButton = ({ onClick, disabled, color, children }) => {
    return (
        <Button
            size="sm"
            variant="twoTone"
            color={color}
            onClick={onClick}
            disabled={disabled}
        >
            {children || 'Generate KB Mockup'}
        </Button>
    )
}

KBMockupTriggerButton.propTypes = {
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    children: PropTypes.node,
}

KBMockupTriggerButton.defaultProps = {
    disabled: false,
}

export default KBMockupTriggerButton
